import { AutoAwesome } from "@mui/icons-material";
import { Grid2, InputAdornment, Typography } from "@mui/material";
import React, { useState } from "react";
import Haley from "../../../../assets/images/Haley.png";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input/index.js";
import {
  StyledFlexColumnView,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";

function Questionnaire({ isEdit, handleClickVerify }) {
  const [formData, setFormData] = useState({
    qs1: "",
    qs2: "",
  });
  const [preScreenQuestions, setPreScreenQuestions] = useState([
    "Key accomplishments as a services company?",
    "How can your expertise help the client",
  ]);

  const qsData = [
    {
      title: "Question 1",
      name: "Key accomplishments as a services company?",
    },
    {
      title: "Question 2",
      name: "How can your expertise help the client ?",
    },
  ];

  const [seededDialog, setSeededDialog] = useState({
    deleteOpen: false,
    loading: false,
    form: "",
    index: "",
    content: "",
    addOpen: false,
  });
  const [deleteDialog, setDeleteDialog] = useState({
    deleteOpen: false,
    loading: false,
    form: "",
    index: "",
    content: "Are you sure you want to delete?",
    addOpen: false,
  });

  const handleSeededClose = () => {
    setSeededDialog({
      content: "",
      index: "",
      form: "",
      deleteOpen: false,
      loading: false,
      addOpen: false,
    });
  };

  const handleAddSeeded = (form) => {
    setSeededDialog((prev) => ({
      ...prev,
      addOpen: true,
      form: form,
    }));
  };

  const handleDeleteQuestionPopup = (index) => {
    setDeleteDialog((prev) => ({
      ...prev,
      deleteOpen: true,
      index: index,
    }));
  };

  const handleDeleteCloseDailog = () => {
    setDeleteDialog((prev) => ({
      ...prev,
      deleteOpen: false,
    }));
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    const updatedQuestions = Array.from(preScreenQuestions);
    const [movedItem] = updatedQuestions.splice(source.index, 1);
    updatedQuestions.splice(destination.index, 0, movedItem);

    setPreScreenQuestions(updatedQuestions);
  };

  const handleAddSubmit = (values, { resetForm }) => {
    setPreScreenQuestions((prevQuestions) => [
      ...prevQuestions,
      values.question,
    ]);
    handleSeededClose(); // Close the dialog after submission
    resetForm(); // Reset form values
  };

  const handleDeleteSkill = () => {
    setDeleteDialog((prev) => ({ ...prev, loading: true }));

    setTimeout(() => {
      setPreScreenQuestions((prev) =>
        prev.filter((_, i) => i !== deleteDialog.index)
      );

      setDeleteDialog({
        deleteOpen: false,
        loading: false,
        form: "",
        index: "",
        content: "Are you sure you want to delete?",
        addOpen: false,
      });
    }, 500); // Simulating an API delay
  };

  const handleChangeText = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12 }}>
        <StyledFlexRowView style={{ gap: "30px" }}>
          <Typography
            sx={{ fontSize: "20px", color: "#101828", fontWeight: 600 }}
          >
            {"Questionnaire"}
          </Typography>

          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Mark as verified"
            padding="8px 15px"
            onClick={handleClickVerify}
          />
        </StyledFlexRowView>
      </Grid2>

      <Grid2 size={6}>
        <StyledFlexColumnView>
          <Typography fontWeight={500} fontSize={"16px"} color={"#475467"}>
            {"Question 1"}
          </Typography>
          <Typography fontWeight={600} fontSize={"16px"} color={"#101828"}>
            {"Key accomplishments as a services company?"}
          </Typography>
          <CommonTextField
            placeholder="Enter Answer"
            multiline
            rows={5}
            fullWidth
            value={formData.qs1}
            onChange={handleChangeText("qs1")}
            padding={"0px"}
          />
        </StyledFlexColumnView>
      </Grid2>
      <Grid2 size={6}></Grid2>

      <Grid2 size={6}>
        <StyledFlexColumnView>
          <Typography fontWeight={500} fontSize={"16px"} color={"#475467"}>
            {"Question 2"}
          </Typography>
          <Typography fontWeight={600} fontSize={"16px"} color={"#101828"}>
            {"How can your expertise help the client ?"}
          </Typography>
          <CommonTextField
            placeholder="Enter Answer"
            multiline
            rows={5}
            fullWidth
            value={formData.qs2}
            onChange={handleChangeText("qs2")}
            padding={"0px"}
          />
        </StyledFlexColumnView>
      </Grid2>

      <Grid2 item size={{ xs: 12 }}>
        <CommonTextField
          border={"0.5px solid #EAECF0"}
          padding={15}
          placeholder={"Ask Haley anything"}
          bgColor={"#F7F8F9"}
          startIcon={
            <InputAdornment position="start">
              <img src={Haley} />
            </InputAdornment>
          }
          endComponent={
            <CommonButton
              // onClick={() => setAi(!ai)}
              fontWeight={600}
              padding={"8px 25px"}
              value={"Ask Haley"}
              endIcon={<AutoAwesome />}
            />
          }
        />
      </Grid2>
    </Grid2>
  );
}

export default Questionnaire;
